(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antbelt-campaign-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  const slugify = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  document.querySelectorAll('.ks-story-exact').forEach((section) => {
    if (section.dataset.tocReady === 'true') return;
    section.dataset.tocReady = 'true';

    const toc = section.querySelector('.ks-story-exact__toc');
    const nav = section.querySelector('.ks-story-exact__toc-links');
    const headings = [...section.querySelectorAll('.ks-story-exact__content h3')];
    const links = headings.map((heading, index) => {
      heading.id = `story-${slugify(heading.textContent) || 'section'}-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.appendChild(link);
      return link;
    });

    let ticking = false;
    const setActiveChapter = () => {
      const currentIndex = headings.reduce((activeIndex, heading, index) => (
        heading.getBoundingClientRect().top <= 160 ? index : activeIndex
      ), 0);
      links.forEach((link) => link.removeAttribute('aria-current'));
      const active = links[currentIndex];
      if (active) {
        active.setAttribute('aria-current', 'true');
        const navRect = toc.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        if (activeRect.top < navRect.top) toc.scrollTop -= navRect.top - activeRect.top + 8;
        if (activeRect.bottom > navRect.bottom) toc.scrollTop += activeRect.bottom - navRect.bottom + 8;
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setActiveChapter);
    }, { passive: true });
    setActiveChapter();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-g1-pledge-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ab-pledge]');
    if (!root || root.dataset.ready === 'shopify-checkout-v2') return;
    root.dataset.ready = 'shopify-checkout-v2';

    const panels = [...root.querySelectorAll('[data-step-panel]')];
    const stepButtons = [...root.querySelectorAll('[data-step-button]')];
    const rewardInputs = [...root.querySelectorAll('input[name="reward"]')];
    const addonInputs = [...root.querySelectorAll('[data-addon]')];
    const nextToAddons = root.querySelector('[data-next-step="2"]');
    const acknowledge = root.querySelector('[data-acknowledge]');
    const reserveButton = root.querySelector('[data-reserve]');
    const reservationForm = root.querySelector('#AntBeltReservationForm');
    const checkoutButton = root.querySelector('[data-checkout]');
    const checkoutError = root.querySelector('[data-checkout-error]');
    const pageBack = root.querySelector('[data-page-back]');
    const backerContext = root.querySelector('[data-backer-context]');
    const backerContextTitle = root.querySelector('[data-backer-context-title]');
    const summaryTrustTitle = root.querySelector('[data-summary-trust-title]');
    const summaryTrustCopy = root.querySelector('[data-summary-trust-copy]');
    const moneyFormat = root.dataset.moneyFormat || '';
    const currency = root.dataset.currency || 'USD';
    const params = new URLSearchParams(window.location.search);
    const requestedStep = params.get('step');
    const requestedSequence = /^\d{1,6}$/.test(params.get('ks_sequence') || '') ? params.get('ks_sequence') : '';
    const flowContext = requestedSequence ? `backer:${requestedSequence}` : 'new';
    const storageKey = `antbeltG1PledgeSelection:${flowContext}`;
    const requestedAddonItemsFromQuery = (params.get('addons') || '')
      .split(',')
      .map((id) => id.trim())
      .filter((id) => /^\d+$/.test(id))
      .map((id) => ({ id, quantity: 1 }));

    pageBack?.addEventListener('click', (event) => {
      if (!document.referrer) return;
      const referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return;
      event.preventDefault();
      window.history.back();
    });
    const flowVariantIds = [
      '46192415211706', '46192415244474', '46192415277242', '46192430776506', '46192430645434',
      '46192430743738', '46192415506618', '46192415310010', '46192415408314', '46192415375546',
      '46192415441082', '46192415473850', '46192415342778', '46192430678202'
    ];
    const backerGroups = JSON.parse(root.querySelector('[data-backer-configurations]')?.textContent || '[]');
    const backerConfiguration = requestedSequence
      ? backerGroups.find((group) => group.sequences.includes(Number(requestedSequence)))
      : null;
    const requestedAddonItems = backerConfiguration
      ? (backerConfiguration.addons || [])
      : requestedAddonItemsFromQuery;

    const cents = (value) => Number(value || 0);
    const formatWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
      const number = cents(value) / 100;
      if (!Number.isFinite(number)) return '0';
      const parts = number.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };
    const formatMoney = (value) => {
      if (!moneyFormat) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency
          }).format(cents(value) / 100);
        } catch (_) {
          return `${currency} ${formatWithDelimiters(value)}`;
        }
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, placeholder) => {
        switch (placeholder) {
          case 'amount_no_decimals':
            return formatWithDelimiters(value, 0);
          case 'amount_with_comma_separator':
            return formatWithDelimiters(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithDelimiters(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithDelimiters(value, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return formatWithDelimiters(value, 0, ' ');
          case 'amount_with_space_separator':
            return formatWithDelimiters(value, 2, ' ', ',');
          case 'amount':
          default:
            return formatWithDelimiters(value);
        }
      });
    };

    const selectedReward = () => rewardInputs.find((input) => input.checked);
    const selectedAddons = () => addonInputs.filter((input) => input.checked);
    const addonQuantityInput = (input) => input.closest('.ab-addon')?.querySelector('[data-addon-quantity]');
    const updateAddonVisualState = (input) => {
      const state = input.closest('.ab-addon')?.querySelector('.ab-addon__state');
      if (state) state.textContent = input.disabled ? 'Unavailable' : input.checked ? 'Selected' : 'Select';
    };
    const addonQuantity = (input) => {
      const quantity = Number(addonQuantityInput(input)?.value || 1);
      return Number.isInteger(quantity) && quantity > 0 ? Math.min(quantity, 20) : 1;
    };
    const selectionData = () => {
      const reward = selectedReward();
      if (!reward) return null;
      return {
        kickstarterSequence: requestedSequence,
        reward: {
          id: reward.value,
          title: reward.dataset.title,
          price: cents(reward.dataset.price),
          image: reward.dataset.image
        },
        addons: selectedAddons().map((input) => ({
          id: input.value,
          title: input.dataset.title,
          price: cents(input.dataset.price),
          image: input.dataset.image,
          quantity: addonQuantity(input),
          kind: input.dataset.kind || 'accessory'
        }))
      };
    };
    const saveSelection = () => {
      const selection = selectionData();
      if (!selection) return;
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(selection));
      } catch (_) {}
    };
    const loadSelection = () => {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (_) {
        return null;
      }
    };

    const renderSummary = () => {
      const selections = [
        selectedReward() ? { input: selectedReward(), quantity: 1 } : null,
        ...selectedAddons().map((input) => ({ input, quantity: addonQuantity(input) }))
      ].filter(Boolean);
      const lines = root.querySelector('[data-summary-lines]');
      const empty = root.querySelector('[data-summary-empty]');
      lines.innerHTML = '';
      empty.hidden = selections.length > 0;
      if (!selections.length) {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Select a reward to continue.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'Reward · Add-ons · Secure checkout';
      } else if (requestedSequence) {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Backer benefits protected.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Priority production · Worldwide delivery';
      } else {
        if (summaryTrustTitle) summaryTrustTitle.textContent = 'Review your selection before checkout.';
        if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Worldwide delivery';
      }
      let total = 0;
      selections.forEach(({ input, quantity }) => {
        total += cents(input.dataset.price) * quantity;
        const line = document.createElement('div');
        line.className = 'ab-summary__line';
        const quantityLabel = quantity > 1 ? ` × ${quantity}` : '';
        line.innerHTML = `<img src="${input.dataset.image}" alt=""><span>${input.dataset.title}${quantityLabel}</span><b>${formatMoney(cents(input.dataset.price) * quantity)}</b>`;
        lines.appendChild(line);
      });
      root.querySelector('[data-summary-total]').textContent = formatMoney(total);
      const rewardField = root.querySelector('[data-reservation-reward]');
      const rewardIdField = root.querySelector('[data-reservation-reward-id]');
      const addonsField = root.querySelector('[data-reservation-addons]');
      const totalField = root.querySelector('[data-reservation-total]');
      const sequenceField = root.querySelector('[data-reservation-sequence]');
      if (rewardField) rewardField.value = selectedReward()?.dataset.title || '';
      if (rewardIdField) rewardIdField.value = selectedReward()?.value || '';
      if (addonsField) addonsField.value = selectedAddons()
        .map((input) => `${input.dataset.title} × ${addonQuantity(input)}`)
        .join(', ') || 'None';
      if (totalField) totalField.value = formatMoney(total);
      if (sequenceField) sequenceField.value = requestedSequence;
      saveSelection();
    };

    const showStep = (step) => {
      panels.forEach((panel) => {
        const isActive = panel.dataset.stepPanel === String(step);
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
      stepButtons.forEach((button) => {
        const isActive = button.dataset.stepButton === String(step);
        button.classList.toggle('is-active', isActive);
        if (isActive) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      const activePanel = panels.find((panel) => panel.dataset.stepPanel === String(step));
      requestAnimationFrame(() => {
        activePanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        activePanel?.querySelector('h2')?.focus({ preventScroll: true });
      });
    };

    rewardInputs.forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('[data-reward-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
        nextToAddons.disabled = false;
        stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
        renderSummary();
      });
    });
    addonInputs.forEach((input) => {
      const quantityInput = addonQuantityInput(input);
      input.addEventListener('change', () => {
        if (quantityInput) {
          quantityInput.value = input.checked
            ? String(Math.max(1, Math.min(20, Number(quantityInput.value) || 1)))
            : '0';
          quantityInput.disabled = !input.checked;
        }
        updateAddonVisualState(input);
        renderSummary();
      });
      quantityInput?.addEventListener('input', () => {
        const quantity = Math.max(1, Math.min(20, Number(quantityInput.value) || 1));
        quantityInput.value = String(quantity);
        if (!input.checked) {
          input.checked = true;
          quantityInput.disabled = false;
        }
        renderSummary();
      });
      quantityInput?.addEventListener('click', (event) => event.stopPropagation());
    });
    if (acknowledge && reserveButton) {
      acknowledge.addEventListener('change', () => { reserveButton.disabled = !acknowledge.checked; });
    }
    if (reservationForm) reservationForm.addEventListener('submit', saveSelection);

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-next-step]');
      if (!button || !root.contains(button)) return;
      const step = Number(button.dataset.nextStep);
      if (step > 1 && !selectedReward()) return;
      showStep(step);
    });
    stepButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.stepButton);
        if (step === 1 || selectedReward()) showStep(step);
      });
    });

    if (requestedSequence && backerContext && backerContextTitle) {
      backerContext.hidden = false;
      backerContextTitle.textContent = `Kickstarter backer #${requestedSequence}`;
      if (summaryTrustTitle) summaryTrustTitle.textContent = 'Backer benefits protected.';
      if (summaryTrustCopy) summaryTrustCopy.textContent = 'Launch price · Priority production · Worldwide delivery';
    }

    const requestedReward = backerConfiguration?.reward || params.get('reward') || '';
    const hasExplicitReward = Boolean(params.get('reward'));
    const savedSelection = loadSelection();
    // Keep a backer's recovered tier/add-ons inside that backer flow. When the
    // same browser opens the new-customer flow, do not inherit the previous
    // backer's session selection.
    const canRestoreSavedSelection = !requestedSequence && !hasExplicitReward && !savedSelection?.kickstarterSequence;
    const requestedInput = rewardInputs.find((input) =>
      input.value === requestedReward
      || (canRestoreSavedSelection && !requestedReward && input.value === savedSelection?.reward?.id)
    );
    if (requestedInput) {
      requestedInput.checked = true;
      root.querySelectorAll('[data-reward-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(requestedInput)));
      nextToAddons.disabled = false;
      stepButtons.slice(1).forEach((button) => button.setAttribute('aria-disabled', 'false'));
    }
    const restoredAddonItems = requestedAddonItems.length
      ? requestedAddonItems
      : canRestoreSavedSelection
        ? (savedSelection?.addons || []).map((addon) => ({
            id: String(addon.id),
            quantity: Number(addon.quantity) || 1
          }))
        : [];
    addonInputs.forEach((input) => {
      const restoredItem = restoredAddonItems.find((item) => String(item.id) === input.value);
      input.checked = Boolean(restoredItem);
      const quantityInput = addonQuantityInput(input);
      if (quantityInput) {
        quantityInput.value = restoredItem ? String(restoredItem.quantity || 1) : '0';
        quantityInput.disabled = !restoredItem;
      }
      updateAddonVisualState(input);
    });

    renderSummary();
    if (requestedInput && requestedReward && (requestedStep === 'addons' || backerConfiguration)) showStep(2);

    if (checkoutButton) {
      checkoutButton.addEventListener('click', async () => {
        const selection = selectionData() || loadSelection();
        if (!selection?.reward?.id) {
          if (checkoutError) {
            checkoutError.hidden = false;
            checkoutError.textContent = 'Your reward selection could not be restored. Please return to Rewards and select it again.';
          }
          return;
        }
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Preparing secure checkout…';
        if (checkoutError) checkoutError.hidden = true;
        try {
          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Unable to read cart');
          const cart = await cartResponse.json();
          const updates = {};
          cart.items.forEach((item) => {
            if (flowVariantIds.includes(String(item.variant_id))) updates[item.key] = 0;
          });
          const kickstarterSequence = /^\d{1,6}$/.test(selection.kickstarterSequence || '')
            ? selection.kickstarterSequence
            : '';
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates,
              attributes: {
                'Kickstarter Backer Sequence': kickstarterSequence,
                'AntBelt Continuation Source': kickstarterSequence ? 'Kickstarter backer continuation' : 'New campaign selection'
              }
            })
          });
          if (!updateResponse.ok) throw new Error('Unable to update cart');

          const items = [selection.reward, ...(selection.addons || [])].map((item, index) => ({
            id: Number(item.id),
            quantity: index === 0 ? 1 : Math.max(1, Number(item.quantity) || 1),
            properties: {
              ...(index === 0 && kickstarterSequence
                ? { '_Kickstarter Backer Sequence': kickstarterSequence }
                : {}),
              '_AntBelt selection type':
                index === 0
                  ? 'Primary reward'
                  : item.kind === 'machine'
                    ? 'Additional machine'
                    : 'Optional add-on'
            }
          }));
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!addResponse.ok) throw new Error('Unable to add pledge selections');
          window.location.assign('/checkout');
        } catch (_) {
          checkoutButton.disabled = false;
          checkoutButton.textContent = 'Continue to secure checkout';
          if (checkoutError) {
            checkoutError.hidden = false;
            checkoutError.textContent = 'We could not prepare checkout. Please try again or contact AntBelt support.';
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-media]').forEach((media) => {
      const playButton = media.querySelector('[data-hero-play]');
      const video = media.querySelector('video');
      if (!playButton || !video) return;

      playButton.addEventListener('click', () => {
        playButton.hidden = true;
        video.play().catch(() => {
          playButton.hidden = false;
        });
      });
    });

    const root = document.querySelector('[data-backer-lookup]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const metricsUrl = root.dataset.campaignMetrics;
    if (metricsUrl) {
      fetch(metricsUrl, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Campaign metrics returned ${response.status}`);
          return response.json();
        })
        .then((metrics) => {
          const hasVerifiedTotals =
            ['current', 'stale'].includes(metrics?.status) &&
            typeof metrics?.total?.amountCents === 'number' &&
            Number.isFinite(metrics.total.amountCents) &&
            typeof metrics?.total?.supporters === 'number' &&
            Number.isFinite(metrics.total.supporters);
          if (!hasVerifiedTotals) {
            return;
          }
          const amount = root.querySelector('[data-campaign-pledged]');
          const supporters = root.querySelector('[data-campaign-supporters]');
          const label = root.querySelector('[data-campaign-label]');
          if (amount) {
            amount.textContent = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: metrics.currency || 'USD',
              maximumFractionDigits: 0
            }).format(metrics.total.amountCents / 100);
          }
          if (supporters) {
            supporters.textContent = new Intl.NumberFormat('en-US').format(
              metrics.total.supporters
            );
          }
          if (label && metrics?.label) label.textContent = metrics.label;

        })
        .catch(() => {});
    }

    const form = root.querySelector('[data-backer-form]');
    const input = form?.elements?.ks_sequence;
    const submit = root.querySelector('[data-backer-submit]');
    const result = root.querySelector('[data-backer-result]');
    const pledgeUrl = root.dataset.pledgeUrl;
    const accountUrl = root.dataset.accountUrl || '/account';
    const backerGroups = [
      { reward: '46192415277242', addons: [], sequences: [5,6,11,17,22,25,35,40,41,48,56,61,65,66,75,77,99,107,114,115,116,128,132,143,151,155,163,169,171,176,180,184,198,200,201,203,208,215,217,220,225,231,239,249,252,259,262,270,272,273] },
      { reward: '46192415277242', addons: ['46192415375546','46192430743738'], sequences: [80,85,86,89,93,95,113,119,122,148,149,162,178,222,224,234,245,258] },
      { reward: '46192415211706', addons: [], sequences: [1,13,15,30,54,63,68,121,152,157,183,211,227,229,240,248] },
      { reward: '46192415244474', addons: [], sequences: [7,27,88,98,117,126,133,154,159,219,221,246,263,265,269] },
      { reward: '46192415277242', addons: ['46192415375546'], sequences: [64,72,92,106,125,156,160,165,187,196,197,216,241,257] },
      { reward: '46192415277242', addons: ['46192430743738'], sequences: [71,100,103,104,140,141,150,161,181,205,226,271] },
      { reward: '46192415277242', addons: ['46192415375546','46192415310010','46192415506618','46192430743738'], sequences: [76,188,210,214,238,244] },
      { reward: '46192415277242', addons: ['46192415375546','46192415310010','46192430743738'], sequences: [112,138,190,206,254] },
      { reward: '46192415277242', addons: ['46192415310010','46192430743738'], sequences: [118,193,204,261] },
      { reward: '46192415277242', addons: ['46192415310010'], sequences: [62,123,247] },
      { reward: '46192415277242', addons: ['46192415342778'], sequences: [90,96,139] },
      { reward: '46192415277242', addons: ['46192415375546','46192415506618','46192430743738'], sequences: [147,182,267] },
      { reward: '46192415244474', addons: ['46192430743738'], sequences: [235,236,260] },
      { reward: '46192415244474', addons: ['46192415375546'], sequences: [79,87] },
      { reward: '46192415277242', addons: ['46192415375546','46192415506618'], sequences: [82,264] },
      { reward: '46192415244474', addons: ['46192415375546','46192430743738'], sequences: [97,168] },
      { reward: '46192415211706', addons: ['46192430743738'], sequences: [167,202] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778'], sequences: [173,268] },
      { reward: '46192415277242', addons: ['46192415506618'], sequences: [228,266] },
      { reward: '46192415277242', addons: ['46192415473850','46192415310010','46192430743738'], sequences: [70] },
      { reward: '46192415244474', addons: ['46192415375546','46192415408314','46192430743738'], sequences: [73] },
      { reward: '46192415277242', addons: ['46192415342778','46192415441082','46192430743738'], sequences: [74] },
      { reward: '46192415277242', addons: ['46192415375546','46192415310010','46192430743738','46192430678202'], sequences: [83] },
      { reward: '46192415244474', addons: ['46192415375546','46192415408314','46192415506618','46192430743738'], sequences: [84] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415408314','46192415441082','46192415310010'], sequences: [91] },
      { reward: '46192415277242', addons: ['46192415408314','46192415310010','46192430743738'], sequences: [94] },
      { reward: '46192415277242', addons: ['46192415375546','46192415408314','46192415506618','46192430743738'], sequences: [108] },
      { reward: '46192415277242', addons: ['46192415310010','46192430678202'], sequences: [120] },
      { reward: '46192415277242', addons: ['46192415375546','46192415473850','46192415310010'], sequences: [130] },
      { reward: '46192415211706', addons: ['46192415506618'], sequences: [131] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192430678202'], sequences: [134] },
      { reward: '46192415277242', addons: ['46192415408314'], sequences: [136] },
      { reward: '46192415211706', addons: ['46192415310010'], sequences: [137] },
      { reward: '46192415244474', addons: ['46192415375546','46192415310010','46192430743738'], sequences: [142] },
      { reward: '46192415277242', addons: ['46192415375546','46192415408314','46192415310010','46192415506618','46192430743738'], sequences: [145] },
      { reward: '46192415277242', addons: ['46192415408314','46192415310010'], sequences: [146] },
      { reward: '46192415277242', addons: ['46192415375546','46192415408314','46192430743738'], sequences: [153] },
      { reward: '46192415277242', addons: ['46192415408314','46192415506618','46192430743738'], sequences: [158] },
      { reward: '46192415211706', addons: ['46192415473850'], sequences: [166] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415310010','46192415506618','46192430743738','46192430678202'], sequences: [170] },
      { reward: '46192415211706', addons: ['46192415375546','46192430743738'], sequences: [172] },
      { reward: '46192415277242', addons: ['46192415310010','46192415506618','46192430743738'], sequences: [177] },
      { reward: '46192415277242', addons: ['46192415342778','46192415408314','46192415310010','46192415506618'], sequences: [185] },
      { reward: '46192415277242', addons: ['46192415375546','46192415408314','46192415310010','46192430743738'], sequences: [186] },
      { reward: '46192415244474', addons: ['46192415342778','46192415310010','46192430743738','46192430678202'], sequences: [189] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415310010','46192430743738'], sequences: [192] },
      { reward: '46192415277242', addons: ['46192415408314','46192415310010','46192415506618'], sequences: [194] },
      { reward: '46192415244474', addons: ['46192415375546','46192415506618'], sequences: [195] },
      { reward: '46192415211706', addons: ['46192415310010','46192430743738'], sequences: [199] },
      { reward: '46192415277242', addons: ['46192415375546','46192415310010'], sequences: [207] },
      { reward: '46192415277242', addons: ['46192415408314','46192430743738'], sequences: [212] },
      { reward: '46192415277242', addons: ['46192415342778','46192415473850','46192430743738'], sequences: [213] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415441082','46192415310010','46192430678202'], sequences: [218] },
      { reward: '46192415211706', addons: ['46192415375546','46192415342778','46192415506618','46192430743738'], sequences: [232] },
      { reward: '46192415277242', addons: ['46192415310010','46192415506618'], sequences: [233] },
      { reward: '46192415277242', addons: ['46192415375546','46192415408314','46192415441082','46192415310010','46192415506618','46192430743738','46192430678202'], sequences: [237] },
      { reward: '46192415277242', addons: ['46192415310010','46192430743738','46192430678202'], sequences: [242] },
      { reward: '46192415211706', addons: ['46192415310010','46192415506618'], sequences: [243] },
      { reward: '46192415277242', addons: ['46192415342778','46192430743738'], sequences: [250] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415506618','46192430743738'], sequences: [251] },
      { reward: '46192415211706', addons: ['46192415310010','46192430743738','46192430678202'], sequences: [253] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415408314','46192415441082','46192415310010','46192415506618','46192430743738','46192430678202'], sequences: [255] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415473850','46192415310010','46192415506618','46192430743738','46192430678202'], sequences: [256] },
      { reward: '46192415277242', addons: ['46192415375546','46192415342778','46192415506618','46192430743738','46192430678202'], sequences: [274] }
    ];
    const genericBackers = [3,4,8,12,14,16,18,19,20,21,23,26,28,31,32,33,34,36,37,38,39,42,43,44,46,47,49,50,52,53,55,57,58,59,60,105,124,164,223];

    const showResult = ({ title, message, actionLabel, actionUrl, className = '' }) => {
      result.className = `ab-backer-result ${className}`.trim();
      result.innerHTML = '';
      const heading = document.createElement('h3');
      heading.textContent = title;
      const copy = document.createElement('p');
      copy.textContent = message;
      result.append(heading, copy);
      if (actionLabel && actionUrl) {
        const action = document.createElement('a');
        action.className = 'button button-primary';
        action.href = actionUrl;
        action.textContent = actionLabel;
        result.appendChild(action);
      }
      result.hidden = false;
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const sequence = String(input?.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = sequence;
      if (!sequence) {
        showResult({
          title: 'Enter your backer number',
          message: 'Use the numeric sequence from your Kickstarter pledge record.',
          className: 'is-warning'
        });
        return;
      }

      const numericSequence = Number(sequence);
      const configuration = backerGroups.find((group) => group.sequences.includes(numericSequence));
      if (configuration) {
        const nextUrl = new URL(pledgeUrl, window.location.origin);
        nextUrl.searchParams.set('ks_sequence', sequence);
        nextUrl.searchParams.set('reward', configuration.reward);
        if (configuration.addons.length) nextUrl.searchParams.set('addons', configuration.addons.join(','));
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Opening…';
        }
        window.location.assign(nextUrl.toString());
        return;
      }

      if (genericBackers.includes(numericSequence)) {
        const nextUrl = new URL(pledgeUrl, window.location.origin);
        nextUrl.searchParams.set('ks_sequence', sequence);
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Opening…';
        }
        window.location.assign(nextUrl.toString());
        return;
      }

      showResult({
        title: 'Backer number not found',
        message: 'Check the number or choose your G1 again.',
        actionLabel: 'View my orders',
        actionUrl: accountUrl,
        className: 'is-warning'
      });
    });

    const requestedSequence = new URLSearchParams(window.location.search).get('ks_sequence');
    if (requestedSequence && form && input) {
      input.value = requestedSequence.replace(/\D/g, '').slice(0, 6);
      form.requestSubmit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-kickstarter-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.ks-archive').forEach((archive) => {
    if (archive.dataset.ready === 'true') return;
    archive.dataset.ready = 'true';

    const search = archive.querySelector('[data-archive-search]');
    const empty = archive.querySelector('[data-archive-empty]');
    const more = archive.querySelector('[data-comments-more]');
    const items = [...archive.querySelectorAll('[data-search]')];
    const replyForm = archive.querySelector('.ks-live-comments__form');
    const replyBody = replyForm?.querySelector('[data-comment-body]');

    archive.querySelectorAll('.ks-archive-comment').forEach((comment) => {
      const meta = comment.querySelector('.ks-archive-comment__meta');
      const author = meta?.querySelector('strong')?.textContent.trim();
      if (!meta || !author || meta.querySelector('[data-comment-reply]')) return;
      const reply = document.createElement('button');
      reply.type = 'button';
      reply.className = 'ks-comment-reply';
      reply.dataset.commentReply = author;
      reply.textContent = 'Reply';
      meta.append(reply);
    });

    archive.addEventListener('click', (event) => {
      const reply = event.target.closest('[data-comment-reply]');
      if (!reply || !replyBody || !replyForm) return;
      const mention = `@${reply.dataset.commentReply} `;
      if (!replyBody.value.startsWith(mention)) replyBody.value = `${mention}${replyBody.value}`;
      replyForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      replyBody.focus({ preventScroll: true });
    });

    const filterItems = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const matches = !query || (item.dataset.search || '').includes(query);
        item.hidden = !matches;
        if (matches) {
          item.classList.remove('is-collapsed');
          visible += 1;
        }
      });
      if (!query) {
        items.forEach((item, index) => {
          if (item.classList.contains('ks-archive-thread')) item.classList.toggle('is-collapsed', index >= 8);
        });
      }
      if (empty) empty.hidden = visible !== 0;
      if (more) more.hidden = Boolean(query) || !items.some((item) => item.classList.contains('is-collapsed'));
    };

    search?.addEventListener('input', filterItems);
    more?.addEventListener('click', () => {
      archive.querySelectorAll('.ks-archive-thread.is-collapsed').forEach((item, index) => {
        if (index < 8) item.classList.remove('is-collapsed');
      });
      more.hidden = !archive.querySelector('.ks-archive-thread.is-collapsed');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antbelt-kickstarter-story-exact"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-campaign-metrics]').forEach((summary) => {
    const metricsUrl = summary.dataset.campaignMetrics;
    if (!metricsUrl || summary.dataset.metricsReady === 'true') return;
    summary.dataset.metricsReady = 'true';

    fetch(metricsUrl, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Campaign metrics returned ${response.status}`);
        return response.json();
      })
      .then((metrics) => {
        const hasVerifiedTotals =
          ['current', 'stale'].includes(metrics?.status) &&
          typeof metrics?.total?.amountCents === 'number' &&
          Number.isFinite(metrics.total.amountCents) &&
          typeof metrics?.total?.supporters === 'number' &&
          Number.isFinite(metrics.total.supporters);
        if (!hasVerifiedTotals) {
          return;
        }
        const amount = summary.querySelector('[data-campaign-pledged]');
        const supporters = summary.querySelector('[data-campaign-supporters]');
        const label = summary.querySelector('[data-campaign-label]');
        if (amount) {
          amount.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: metrics.currency || 'USD',
            maximumFractionDigits: 0
          }).format(metrics.total.amountCents / 100);
        }
        if (supporters) {
          supporters.textContent = new Intl.NumberFormat('en-US').format(
            metrics.total.supporters
          );
        }
        if (label && metrics?.label) label.textContent = metrics.label;

      })
      .catch(() => {});
  });

  document.querySelectorAll('[data-hero-media]').forEach((media) => {
    const playButton = media.querySelector('[data-hero-play]');
    const video = media.querySelector('video');
    if (!playButton || !video) return;

    playButton.addEventListener('click', () => {
      playButton.hidden = true;
      video.play().catch(() => {
        playButton.hidden = false;
      });
    });
  });

  const slugify = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  document.querySelectorAll('.ks-story-exact').forEach((section) => {
    if (section.dataset.tocReady === 'true') return;
    section.dataset.tocReady = 'true';

    const toc = section.querySelector('.ks-story-exact__toc');
    const nav = section.querySelector('.ks-story-exact__toc-links');
    const mobilePledge = section.querySelector('[data-mobile-pledge]');
    const rewards = section.querySelector('#available-rewards');
    if (mobilePledge && rewards && 'IntersectionObserver' in window) {
      const rewardObserver = new IntersectionObserver(([entry]) => {
        mobilePledge.classList.toggle('is-hidden', entry.isIntersecting);
      }, { threshold: 0.05 });
      rewardObserver.observe(rewards);
    }
    const allHeadings = [...section.querySelectorAll('.ks-story-exact__content h3')];
    allHeadings.forEach((heading, index) => {
      heading.id = `story-${slugify(heading.textContent) || 'section'}-${index + 1}`;
    });
    const featuredChapters = [
      'AntBelt G1: Real Galvo Power, Starting From $99',
      'See The Machine Work Before You Back',
      'The Big Difference: 80 x 80mm Daily Jobs, 80 x 2000mm Long Projects',
      'AntBelt Studio: Software Is Part Of The Product',
      'Rotary Roller And Chuck Options For More Products',
      'Accessories & Add-Ons, That Expand Your Workflow',
      'Key Features At A Glance',
      "What's In The Box",
      'Production And QC Plan',
      'Shipping And Fulfillment',
      'FAQ',
      'Meet The Team Building The Tool'
    ];
    const headings = allHeadings.filter((heading) => featuredChapters.includes(heading.textContent.trim()));
    const links = headings.map((heading, index) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.appendChild(link);
      return link;
    });

    let ticking = false;
    const setActiveChapter = () => {
      const currentIndex = headings.reduce((activeIndex, heading, index) => (
        heading.getBoundingClientRect().top <= 160 ? index : activeIndex
      ), 0);
      links.forEach((link) => link.removeAttribute('aria-current'));
      const active = links[currentIndex];
      if (active) {
        active.setAttribute('aria-current', 'true');
        const navRect = toc.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        if (activeRect.top < navRect.top) toc.scrollTop -= navRect.top - activeRect.top + 8;
        if (activeRect.bottom > navRect.bottom) toc.scrollTop += activeRect.bottom - navRect.bottom + 8;
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setActiveChapter);
    }, { passive: true });
    setActiveChapter();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
